<svelte:head>
  <title>Preferences | A Good Thing</title>
</svelte:head>

{#if data.preferences && data.preferences.businessNotifyNeeds}
<div class="subtitle">Charity needs</div>
<div class="field is-horizontal">
  <div class="control">
      <input id="notify" bind:checked={data.preferences.businessNotifyNeeds.enabled} type="checkbox" class="switch is-success" on:change={save}>
      <label for="notify">Notify me about local charity needs</label>
  </div>
</div>


{#if data.preferences.businessNotifyNeeds.enabled}

<div class="field">
  <label class="label">Charities within</label>
  <div class="control">
    <div class="select">
      <select bind:value={data.preferences.businessNotifyNeeds.distance} on:change={save}>
        <option value={1}>1 mile</option>
        <option value={2}>2 miles</option>
        <option value={3}>3 miles</option>
        <option value={5}>5 miles</option>
        <option value={10}>10 miles</option>
        <option value={15}>15 miles</option>
        <option value={20}>20 miles</option>
        <option value={25}>25 miles</option>
        <option value={0}>any distance</option>
      </select>
    </div>
  </div>
</div>

<div class="field">
    <label class="label">Schedule</label>
  
    <div class="control">
      <div class="select">
        <select bind:value={data.preferences.businessNotifyNeeds.frequency} on:change={save}>
          <option value={'immediate'}>Straight away</option>
          <option value={'weekly'}>Weekly</option>
          <option value={'monthly'}>Monthly</option>
        </select>
      </div>
    </div>
    
</div>

{/if}

{/if}


<script lang="ts">
  import _ from "lodash";
  import { appState } from "../../../lib/appState";

  let data = _.cloneDeep($appState.user) as User_v1;

  if (data.preferences == undefined) {
    data.preferences = {};
  }

  if(data.preferences.businessNotifyNeeds == undefined) {
    data.preferences.businessNotifyNeeds = {
      enabled: true,
      distance: 5,
      frequency: 'weekly'
    };
  } 

  let showToast = false;

  let isLoading = false;

  let firebase = window.firebase;

  async function save() {
    isLoading = true;

    await firebase
      .firestore()
      .collection("users_v1")
      .doc($appState.auth_user.email)
      .update(data);

    $appState.user = data;

    isLoading = false;

    showToast = true;
  }
</script>
